import { Box, Chip, Stack } from '@mui/material';
import IconButtonMenu from '../components/Redesing/icon-button-menu';
import ColumnAvatar from '../components/Redesing/column-avatar';
import DeleteIcon from '@mui/icons-material/Delete';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

// Mirrors the status chip used by the sidebar system selector so the two
// system lists stay visually consistent.
const getStatusChip = (status) => {
  switch (status) {
    case 'hibernation':
      return (
        <Chip
          icon={<PauseCircleIcon />}
          label="Hibernating"
          color="warning"
          size="small"
          variant="outlined"
        />
      );
    case 'closed':
      return (
        <Chip
          icon={<CancelIcon />}
          label="Closed"
          color="error"
          size="small"
          variant="outlined"
        />
      );
    case 'open':
    default:
      return (
        <Chip
          icon={<CheckCircleIcon />}
          label="Open"
          color="success"
          size="small"
          variant="outlined"
        />
      );
  }
};

export const OrganizationSystemColumns = (setSelectedSystem, setConfirm) => [
  {
    id: 'name',
    label: `System Name`,
    showToolTip: true,
    format: (row) => (
      <ColumnAvatar noEllipsis avatar={<AccountTreeIcon />} firstRow={row.name} />
    ),
  },
  {
    id: 'status',
    label: `Status`,
    format: (row) => <Box>{getStatusChip(row.status)}</Box>,
  },
  {
    id: 'actions',
    label: `Actions`,
    hidden: true,
    format: (row) => {
      const arrayBtns = [
        {
          label: '',
          startIcon: <DeleteIcon />,
          onClick: (e) => {
            e.stopPropagation();
            setSelectedSystem(row);
            setConfirm(true);
          },
        },
      ];

      return (
        <Stack justifyContent={'flex-start'} alignItems={'flex-start'}>
          <IconButtonMenu buttons={arrayBtns} />
        </Stack>
      );
    },
  },
];
